//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    rowData: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      search: {
      },
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    },
    rowData: {
      handler (val) {
        if (val) {
          this.handleTableData()
        }
      },
      deep:true
    },
  },
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  methods: {
    handleTableData () {
      let table = []
      if (this.rowData) {
        _.each(this.rowData.dealerList, (t, i, l) => {
          let f = _.findWhere(this.rowData.selectedDealer, {selectedDealerId:  t.dealerId})
          if (!f) {
            table.push(t)
          }
        })
      }
      this.table = table
    },
    handleSubmit (row) {
      this.$emit('submit', row)
      this.$emit('update:visible', false)
    },
    handleOpen () {
      this.handleTableData()
    }
  }
}
